import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const PersonColorLegend = ({ 
  layout = 'vertical',
  onPersonUpdate,
  className = ''
}) => {
  const [persons, setPersons] = useState([
    {
      id: 1,
      name: 'Sarah',
      role: 'Mom',
      color: '#EF4444',
      initials: 'SM'
    },
    {
      id: 2,
      name: 'Michael',
      role: 'Dad',
      color: '#3B82F6',
      initials: 'MD'
    },
    {
      id: 3,
      name: 'Emma',
      role: 'Daughter',
      color: '#EC4899',
      initials: 'ED'
    },
    {
      id: 4,
      name: 'Lucas',
      role: 'Son',
      color: '#10B981',
      initials: 'LS'
    }
  ]);

  const [editingPerson, setEditingPerson] = useState(null);

  const handleColorChange = (personId, newColor) => {
    const updatedPersons = persons?.map(person =>
      person?.id === personId ? { ...person, color: newColor } : person
    );
    setPersons(updatedPersons);
    
    if (onPersonUpdate) {
      onPersonUpdate(updatedPersons);
    }
  };

  const handleEditClick = (person) => {
    setEditingPerson(person?.id === editingPerson ? null : person?.id);
  };

  const predefinedColors = [
    '#EF4444', '#F97316', '#F59E0B', '#EAB308',
    '#84CC16', '#10B981', '#14B8A6', '#06B6D4',
    '#3B82F6', '#6366F1', '#8B5CF6', '#A855F7',
    '#EC4899', '#F43F5E'
  ];

  const isHorizontal = layout === 'horizontal';

  return (
    <div 
      className={`person-color-legend ${isHorizontal ? 'person-color-legend-horizontal' : ''} ${className}`}
      role="region"
      aria-label="Family member color legend"
    >
      {!isHorizontal && (
        <h3 className="person-color-legend-title">Family Members</h3>
      )}
      <div className={`${isHorizontal ? 'flex gap-3' : 'person-color-legend-list'}`}>
        {persons?.map((person) => (
          <div 
            key={person?.id}
            className="person-color-legend-item"
            onClick={() => handleEditClick(person)}
          >
            <div 
              className="person-color-legend-color"
              style={{ backgroundColor: person?.color }}
              aria-label={`${person?.name}'s color`}
            >
              {isHorizontal && (
                <div className="w-full h-full flex items-center justify-center text-white text-xs font-semibold">
                  {person?.initials}
                </div>
              )}
            </div>
            
            <div className="person-color-legend-info">
              <div className="person-color-legend-name">{person?.name}</div>
              <div className="person-color-legend-role">{person?.role}</div>
            </div>

            {!isHorizontal && (
              <div className="person-color-legend-actions">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={(e) => {
                    e?.stopPropagation();
                    handleEditClick(person);
                  }}
                  aria-label={`Edit ${person?.name}'s color`}
                >
                  <Icon name="palette" size={16} />
                </Button>
              </div>
            )}

            {editingPerson === person?.id && !isHorizontal && (
              <div 
                className="absolute top-full left-0 mt-2 bg-popover border border-border rounded-lg p-3 shadow-warm-lg z-[200]"
                onClick={(e) => e?.stopPropagation()}
              >
                <div className="grid grid-cols-7 gap-2">
                  {predefinedColors?.map((color) => (
                    <button
                      key={color}
                      className="w-8 h-8 rounded-lg transition-transform hover:scale-110 active:scale-95"
                      style={{ backgroundColor: color }}
                      onClick={() => handleColorChange(person?.id, color)}
                      aria-label={`Select color ${color}`}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PersonColorLegend;